module.exports = __webpack_public_path__ + "static/media/1350_Cart_GiftShop_thanksPopup.8cbb30ff.png";